module.exports = __webpack_public_path__ + "img/deak-bg.6ec3f72f.jpg";